import React from 'react'
import { ContentColumn } from '../..'
import BenchmarkingPlaceholder from '../../components/BenchmarkingPlaceholder'

// "Fördjupning per insats" — intern vy med dropdown för vald insats. Vald insats
// visas tvärs över alla vyer (förekomst, frekvens, nivåfördelning, kombinationer m.m.).
export const benchmarkingCalculationDeepDive: ContentColumn[] = [
  {
    pageTitle: 'Fördjupning per insats',
    content: (
      <BenchmarkingPlaceholder
        text={
          <>
            <b>Beskrivning</b>
            <br />
            Fördjupad analys av en vald insats (dropdown). Visar förekomst, frekvens, antal unika
            besök/dag, nivåfördelning, kombinationer med andra insatser, tidpunkter och timmar per nivå.
            <br />
            <br />
            <b>Status</b>
            <br />
            Strukturen är på plats. Insats-dropdownen återanvänder mönstret från Volym &gt; Datakälla.
            Detta är en intern vy (ingen kommunjämförelse).
          </>
        }
      />
    ),
  },
]
